import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { uiLocale } from "./index";

// Puts the portal language on <html lang> while a portal or sign-in page is
// open (screen readers, `hyphens: auto` for long German words), and gives the
// marketing pages back their English when the page closes.
export function useDocumentLanguage(): void {
  const { i18n } = useTranslation();
  useEffect(() => {
    const root = document.documentElement;
    root.lang = uiLocale().split("-")[0];
    return () => {
      root.lang = "en";
    };
  }, [i18n.language]);
}
